import type {
    Business,
    BusinessSignup,
    BusinessSignupNote,
    Pageable,
} from '@barboxx/models/types';

import { api } from '../api';

const rootPath = 'businesses';
const signupRootPath = `${rootPath}/signup`;

export function getBusinesses(query?: Business.SearchQuery) {
    return api.get<Business.SearchResponse>(rootPath, query);
}

export function getBusiness(id: number) {
    return api.get<Business.DetailsResponse>(`${rootPath}/${id}`);
}

export function updateBusiness(id: number, data: Business.UpdateRequest) {
    return api.put<Business>(`${rootPath}/${id}`, data);
}

export function createBusiness(data: Business.CreateRequest) {
    return api.post<Business.CreateRequest, Business>(rootPath, data);
}

export function getSignups(data?: Pageable) {
    return api.get<BusinessSignup.SearchResponse>(signupRootPath, data);
}

export function getSignupById(id: number) {
    return api.get<BusinessSignup>(`${signupRootPath}/${id}`);
}

export function updateSignupById({
    id,
    ...data
}: BusinessSignup.UpdateRequest) {
    return api.put(`${signupRootPath}/${id}`, data);
}

export function addNoteToSignup(
    id: number,
    data: Pick<BusinessSignupNote.CreateRequest, 'content'>
) {
    return api.post(`${signupRootPath}/${id}/note`, data);
}
